import { useEffect, useState } from "react";
import http from "services/httpService";

function useFetchCd({ presist }) {
  const [cdDetail, setCdDetail] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCd();
  }, []);

  const fetchCd = async () => {
    setLoading(true);
    try {
      const { data } = await http.get(`/business/view_cd_balance/`);
      setCdDetail(data);
      presist && sessionStorage.setItem("cashDesposit", JSON.stringify(data));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  return { cdDetail, loading };
}

export default useFetchCd;
